<script setup>
import { token_expired } from "@/assets/js/token_expired";
import axios from "axios";
import Swal from "sweetalert2";
// import gb from "@/components/bg.vue";
import v_header from "@/components/header.vue";
import v_menu from "@/components/menu.vue";
import e_book from "@/components/e_book.vue";
import resources from "@/components/resources.vue";
import media from "@/components/media.vue";

import v_audio from "@/components/audio.vue";
import v_video from "@/components/video.vue";

import v_public from "@/components/public.vue";
import v_mask from "@/components/mask.vue";
import { ref, onMounted, watch, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
// import { forEach } from "core-js/core/array";

const store = useStore();
const router = useRouter();

const menu = ref(null);

const main = ref(null);
const wrapper = ref(null);
const logo = ref(null);
const media_win = ref(null);

const ebooks_premium = ref(false);

const sub_menu = (data) => {
  menu.value = data;
};

const load = ref(false);
const view = ref(false);

// ▼電子書資料 子傳父
const e_book_open = ref(false);

const Ebook_name = ref("");

const Ebook_guid = ref("");

const Ebook_premium = ref("");

const e_book_win = ref(null);

const sbu_Ebook_open = (data) => {
  e_book_open.value = data;
};

const sbu_Ebook_name = (data) => {
  Ebook_name.value = data;
};

const sbu_Ebook_guid = (data) => {
  Ebook_guid.value = data;
};

const sbu_Ebook_premium = (data) => {
  Ebook_premium.value = data;
};

// const sbu_Ebook_link = (data) => {
//   Ebook_link.value = data;
// };
// ▲電子書資料 子傳父

const student_book = ref([
  // {
  //   guid: "84686464",
  //   name: "Class Stanford",
  //   time: "2024/7/7 07:07",
  //   link: "google.com",
  // },
]);

const choose_student_book = ref({
  guid: null,
  name: null,
  time: null,
  link: null,
});

function del_student_book(index) {
  let book_code = Ebook_guid.value;
  let account = localStorage.getItem("ac");
  let subject = student_book.value[index].subject;

  console.log(book_code);
  console.log(account);
  console.log(subject);

  // return;

  Swal.fire({
    // title: "確定!",
    text: "Are you sure to delete this item?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Delete",
    cancelButtonText: "Cancel",
  }).then((result) => {
    if (result.isConfirmed) {
      const FormData = require("form-data");
      let data = new FormData();
      data.append("book_code", book_code);
      data.append("account", account);
      data.append("subject", subject);
      data.append("ver", student_book.value[index].ver);

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${store.state.path}api/db/ebooks-record/delete`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          token_expired(response);

          if (response.data.code == -2) {
            // 帳號沒有權限
            Swal.fire({
              title: "Error",
              text: "This account is not enabled.",
              icon: "error",
              confirmButtonText: "Close",
            });
            router.push("/");
            return;
          }

          if (response.data.code == -3) {
            // 帳號到期
            Swal.fire({
              title: "Error",
              text: "This account has expired.",
              icon: "error",
              confirmButtonText: "Close",
            });
            router.push("/");
            return;
          }

          console.log(response.data);

          Swal.fire({
            title: "Information",
            text: "Delete successfully",
            icon: "success",
          });

          ebooks_record_get();
          choose_student_book_remake();
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (result.isDismissed) {
      Swal.fire({
        title: "Cancel",
        text: "Undelete",
        icon: "warning",
      });
    }
  });
}

function get_info() {
  const FormData = require("form-data");
  let data = new FormData();
  data.append("tch_account", localStorage.getItem("ac"));

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${store.state.path}api/db/teacher-info/get`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: data,
  };

  axios
    .request(config)
    .then((response) => {
      if (response.data.code == -2) {
        // 帳號沒有權限
        Swal.fire({
          title: "Error",
          text: "This account is not enabled.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if (response.data.code == -3) {
        // 帳號到期
        Swal.fire({
          title: "Error",
          text: "This account has expired.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if (response.status == 520) {
        get_info();
      }

      token_expired(response, router);

      localStorage.getItem("level");
      localStorage.getItem("choose");

      // ebooks_premium.value = response.data.data.series_permissions.find(item => item.series_name == localStorage.getItem("level"));

      const result = response.data.data.series_permissions.find(
        (item) => item.series_name === localStorage.getItem("level")
      );

      ebooks_premium.value = result.ebooks == "premium";
    })
    .catch((error) => {
      console.log(error.response.data.code);

      if (error.response.data.code == -2) {
        // 帳號沒有權限
        Swal.fire({
          title: "Error",
          text: "This account is not enabled.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if (error.response.data.code == -3) {
        // 帳號到期
        Swal.fire({
          title: "Error",
          text: "This account has expired.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if (error.status == 520) {
        get_info();
      }
      console.log(error);
    });
}

function e_book_open_btn() {
  //略過

  const FormData = require("form-data");
  let data = new FormData();
  data.append("book_code", Ebook_guid.value);
  data.append("os", "web");

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${store.state.path}api/db/ebooks-info/get`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: data,
  };

  axios
    .request(config)
    .then((response) => {
      if (response.status == 520) {
        e_book_open_btn();
      }

      token_expired(response);
      console.log("----------");
      console.log(response);
      // console.log(Ebook_guid.value);
      // console.log(response.data.data.url);
      let ac = localStorage.getItem("ac");
      let path = `${store.state.path}`;
      let api = `${path}api/`;
      console.log("EB", response);
      let ebook = response.data.data.url.replace("/index.html", "/ebook");
      let premium = "standard"; //premium stand

      const FormData = require("form-data");
      let data = new FormData();

      data.append("tch_account", localStorage.getItem("ac"));

      if (ebooks_premium.value) {
        premium = "premium";
      }

      let str = `account=${ac}&api=${api}&ebook=${ebook}&type=${premium}`;

      console.log("str", str);

      let bearer = localStorage.getItem("token");
      let base64 = encodeToBase64(str);
      let openUrl = `https://peterbear-wordking.s3.ap-northeast-1.amazonaws.com/pbt/player/index.html?x=${base64}&b=${bearer}`;

      console.log("----------");
      // window.open(response.data.data.url);
      window.location.href = openUrl;
    })
    .catch((error) => {
      if (error.status == 520) {
        e_book_open_btn();
      }

      console.log(error);
    });

  choose_student_book_remake();
}

function encodeToBase64(input) {
  // 檢查瀏覽器是否支持 btoa() 函數
  if (typeof btoa === "function") {
    return btoa(unescape(encodeURIComponent(input)));
  } else {
    console.error("Base64 encoding is not supported in this environment.");
  }
}

function choose_student_book_remake() {
  e_book_open.value = false;

  choose_student_book.value.guid = null;
  choose_student_book.value.name = null;
  choose_student_book.value.time = null;
  choose_student_book.value.link = null;
}

function e_book_log_open_btn() {
  //開啟紀錄

  // 被選取的紀錄
  console.log(choose_student_book.value);

  const FormData = require("form-data");
  let data = new FormData();
  data.append("book_code", Ebook_guid.value);
  data.append("os", "web");

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${store.state.path}api/db/ebooks-info/get`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: data,
  };

  axios
    .request(config)
    .then((response) => {
      if (response.status == 520) {
        e_book_log_open_btn();
      }

      token_expired(response);
      console.log("----------");
      // console.log(response);
      // console.log(Ebook_guid.value);
      // console.log(response.data.data.url);
      let ac = localStorage.getItem("ac");

      let path = `${store.state.path}`;
      let api = `${path}api/`;
      console.log("EB", response);
      let ebook = response.data.data.url.replace("/index.html", "/ebook");
      let premium = "standard"; //premium stand
      if (ebooks_premium.value) {
        premium = "premium";
      }

      let str = `account=${ac}&api=${api}&ebook=${ebook}&record=${choose_student_book.value.subject}&type=${premium}`;

      console.log("str", str);

      let bearer = localStorage.getItem("token");
      let base64 = encodeToBase64(str);
      let openUrl = `https://peterbear-wordking.s3.ap-northeast-1.amazonaws.com/pbt/player/index.html?x=${base64}&b=${bearer}`;

      console.log("----------");
      // window.open(response.data.data.url);
      window.location.href = openUrl;
    })
    .catch((error) => {
      if (error.status == 520) {
        e_book_log_open_btn();
      }

      console.log(error);
    });

  choose_student_book_remake();
}

// ▼多媒體資料 子傳父
const media_open = ref(false);
const audio_open = ref(true);
const media_name = ref("");
const media_link = ref("");
const media_class = ref("");

const sbu_media_open = (data) => {
  media_open.value = data;
};

const sbu_audio_open = (data) => {
  audio_open.value = data;
};

const sbu_media_name = (data) => {
  media_name.value = data;
};

const sbu_media_link = (data) => {
  media_link.value = data;
};

const sbu_media_class = (data) => {
  media_class.value = data;
};
// ▲多媒體資料 子傳父

function ebooks_record_get() {
  student_book.value = [];
  const FormData = require("form-data");
  let data = new FormData();
  data.append("book_code", Ebook_guid.value);
  data.append("account", localStorage.getItem("ac"));

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${store.state.path}api/db/ebooks-record/get`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: data,
  };

  axios
    .request(config)
    .then((response) => {
      if (response.status == 520) {
        ebooks_record_get();
      }

      token_expired(response);
      console.log(response.data);
      student_book.value = response.data.data;
    })
    .catch((error) => {
      if (error.status == 520) {
        ebooks_record_get();
      }
      console.log(error);
    });
}

function formatDateTime(dateTimeStr) {
  // 提取年、月、日、時、分
  const year = dateTimeStr.slice(0, 4);
  const month = dateTimeStr.slice(4, 6);
  const day = dateTimeStr.slice(6, 8);
  const hour = dateTimeStr.slice(8, 10);
  const minute = dateTimeStr.slice(10, 12);

  // 組合成 YYYY-MM-DD HH:MM 格式
  return `${year}-${month}-${day} ${hour}:${minute}`;
}

// function adjustScale(element) {
//   // 獲取當前的縮放比例
//   const currentZoom = window.devicePixelRatio || 1;

//   // 反向縮放，使之看起來像 100%
//   const inverseZoom = 1 / currentZoom;

//   // 使用 CSS transform 來反向縮放
//   if (element == wrapper.value) {
//     let w = 315;

//     if (window.innerWidth <= 1366) {
//       w = 250;
//     }

//     element.style.cssText = `grid-template-columns: calc(${w}px * ${inverseZoom}) calc(100% - ${w}px * ${inverseZoom}); grid-template-rows: calc(120px * ${inverseZoom}) calc(100% - (120px * ${inverseZoom}));`;
//   } else if (element == logo.value) {
//     let yx = `-${100 - (inverseZoom * 100 - inverseZoom)}%`;
//     element.style.transform = `scale(${inverseZoom}) translate(${yx}, ${yx})`;
//   } else if (element == e_book_win.value || element == media_win.value) {
//     element.style.zoom = `${inverseZoom - 0.075}`;
//   } else {
//     element.style.zoom = `${inverseZoom}`;
//   }
// }

watch(
  () => menu.value,
  () => {
    audio_open.value = false;
    media_open.value = false;
  }
);

// watch(
//   () => route.path,
//   () => {
//     audio_open.value = false;
//     media_open.value = false;
//   }
// );

watch(
  () => e_book_open.value,
  () => {
    console.log("連結變動");

    // console.log(Ebook_name.value);
    // console.log(Ebook_guid.value);

    console.log("book_code", Ebook_guid.value);
    console.log("account", localStorage.getItem("ac"));

    if (Ebook_guid.value) {
      ebooks_record_get();
    }

    // if (e_book_open.value) {
    //   setTimeout(() => {
    //     adjustZoom(e_book_win.value);
    //   }, 100);
    // }
  }
);

// watch(
//   () => media_open.value,
//   () => {
//     if (media_open.value) {
//       setTimeout(() => {
//         adjustZoom(media_win.value);
//       }, 100);
//     }
//   }
// );

const adjustZoom = (view) => {
  const baseWidth = 1920;
  const baseHeight = 1080;

  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;

  const scaleWidth = windowWidth / baseWidth;
  const scaleHeight = windowHeight / baseHeight;

  const scale = Math.min(scaleWidth, scaleHeight);

  if (view) {
    view.style.transform = `scale(${scale})`;

    setTimeout(() => {
      const wrapper = document.querySelector(".wrapper");
      const body = document.querySelector("body");

      const wrapperWidth = wrapper.getBoundingClientRect().width;
      const bodyWidth = body.getBoundingClientRect().width;

      const difference = bodyWidth - wrapperWidth;
      const left = difference / 2;

      console.log("wrapper 小 body:", difference, "px");
      console.log("需要設定的 left 值:", left, "px");

      // 設置 left 居中
      wrapper.style.left = `${left}px`;
    }, 50);
  }
};

watch(
  () => load.value,
  () => {
    if (load.value) {
      console.log("畫面載入成功");
      adjustZoom(wrapper.value);
      view.value = true;
    }
  }
);

const sortedStudentBook = computed(() => {
  // 深拷貝一份原資料，避免直接修改原資料
  return [...student_book.value].sort((a, b) => {
    const dateA = new Date(
      a.ver.slice(0, 4), // 年
      a.ver.slice(4, 6) - 1, // 月 (JavaScript 的月份是從 0 開始)
      a.ver.slice(6, 8), // 日
      a.ver.slice(8, 10), // 小時
      a.ver.slice(10, 12), // 分鐘
      a.ver.slice(12, 13) // 秒數
    );
    const dateB = new Date(
      b.ver.slice(0, 4),
      b.ver.slice(4, 6) - 1,
      b.ver.slice(6, 8),
      b.ver.slice(8, 10),
      b.ver.slice(10, 12),
      b.ver.slice(12, 13)
    );
    return dateB - dateA; // 由新到舊排序
  });
});

onMounted(() => {
  get_info();
  // certification();
  if (localStorage.getItem("menu")) {
    menu.value = Number(localStorage.getItem("menu"));
  } else {
    menu.value = 0;
  }

  setTimeout(() => {
    load.value = true;
  }, 600);

  // setTimeout(() => {
  // adjustScale(logo.value);
  // adjustScale(main.value);
  // adjustScale(wrapper.value);
  // }, 650);
});
</script>

<template>
  <div id="home">
    <!-- <gb /> -->
    <div class="wrapper" ref="wrapper" v-show="view">
      <div id="logo" ref="logo" v-if="load">
        <img class="pic_logo" src="@/assets/images/new-logo.png" alt="star" />
      </div>
      <v_header v-if="load" @sbu_audio_open="sbu_audio_open" />
      <v_menu v-if="load" @sub_menu="sub_menu" />

      <main v-if="load" ref="main">
        <e_book
          v-if="menu == 0"
          @sbu_Ebook_open="sbu_Ebook_open"
          @sbu_Ebook_name="sbu_Ebook_name"
          @sbu_Ebook_guid="sbu_Ebook_guid"
          @sbu_Ebook_premium="sbu_Ebook_premium"
        />
        <resources v-if="menu == 1" />
        <media
          v-if="menu == 2"
          @sbu_media_open="sbu_media_open"
          @sbu_media_name="sbu_media_name"
          @sbu_audio_open="sbu_audio_open"
          @sbu_media_link="sbu_media_link"
          @sbu_media_class="sbu_media_class"
        />
        <v_public
          v-if="menu == 3"
          @sbu_media_open="sbu_media_open"
          @sbu_media_name="sbu_media_name"
          @sbu_audio_open="sbu_audio_open"
          @sbu_media_link="sbu_media_link"
          @sbu_media_class="sbu_media_class"
        />
      </main>

      <div
        v-if="!load"
        style="
          position: absolute;
          width: calc(100% - 100px);
          height: calc(100% - 100px);
          border: 2px solid #fff;
          margin: 50px;
          border-radius: 25px;
          background-color: rgba(0, 0, 0, 0.25);
        "
      >
        <h6
          style="
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            color: #fff;
            font-size: 60px;
            text-shadow: 0 5px 12px #888;
          "
        >
          LOADING...
        </h6>
      </div>
    </div>

    <!-- ▼電子書視窗▼ -->
    <transition name="fade">
      <v_mask v-if="e_book_open" />
    </transition>

    <transition name="fade">
      <div v-if="e_book_open" id="e_book_win" ref="e_book_win">
        <div class="top" :data-title="Ebook_name">
          <button @click="choose_student_book_remake()" />
        </div>
        <div id="e_book_win_wrapper">
          <div id="e_book_win_content">
            <!-- <h3
              style="
                margin-bottom: 0;
                position: absolute;
                top: 0;
                color: #4162a2;
                left: 0;
                right: 0;
                margin-top: 15px;
                pointer-events: none;
              "
            >
              {{ Ebook_name }}
            </h3> -->
            <div class="content">
              <div class="title">History</div>
              <div class="list">
                <table>
                  <tbody>
                    <tr
                      v-for="(item, index) in sortedStudentBook"
                      :key="index"
                      :class="{ active: item.guid == choose_student_book.guid }"
                    >
                      <td @click="choose_student_book = item">
                        <img
                          class="icon"
                          src="@/assets/images/e-book/time.svg"
                          alt="icon"
                        />
                        <span>{{ item.subject }}</span>
                      </td>
                      <td @click="choose_student_book = item">
                        <span>{{ formatDateTime(item.ver) }}</span>
                      </td>
                      <td>
                        <button @click="del_student_book(index)">Delete</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="btn">
                <button @click="e_book_open_btn()">Skip</button>
                <button v-if="choose_student_book.guid" @click="e_book_log_open_btn()">
                  Load
                </button>
                <button v-else style="filter: grayscale(1); cursor: no-drop">Load</button>
                <!-- <button @click="e_book_open_btn()">Skip</button>
                <button @click="e_book_log_open_btn()">Load</button> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- ▲電子書視窗▲ -->

    <!-- ▼多媒體音檔▼ -->
    <transition name="fade-up">
      <v_audio
        v-if="load"
        v-show="audio_open"
        :media_name="media_name"
        :media_link="media_link"
        :audio_open="audio_open"
        @sbu_audio_open="sbu_audio_open"
      />
    </transition>
    <!-- ▲多媒體音檔▲ -->

    <!-- ▼多媒體影片▼ -->
    <transition name="fade">
      <v_mask v-if="media_open && media_class === 'video'" />
    </transition>

    <transition name="fade">
      <div id="media_win" ref="media_win" v-if="media_open && media_class === 'video'">
        <div class="top" :data-title="media_name">
          <button @click="media_open = false" />
        </div>
        <div id="media_win_wrapper" style="position: relative">
          <div id="media_win_content">
            <!-- <h3
              style="
                margin-bottom: 0;
                position: absolute;
                top: 0;
                color: #4162a2;
                left: 0;
                right: 0;
                margin-top: 15px;
                pointer-events: none;
              "
            >
              {{ media_name }}
            </h3> -->
            <div
              class="content"
              style="
                height: auto;
                display: flex;
                align-items: center;
                justify-content: center;
                aspect-ratio: 16 / 9;
              "
            >
              <v_video :media_link="media_link" v-if="1" />
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- ▲多媒體影片▲ -->
  </div>
</template>

<style lang="scss" scoped>
/* 向上浮出效果 */
.fade-up-enter-active,
.fade-up-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.fade-up-enter-from,
.fade-up-leave-to {
  opacity: 0;
  transform: translateY(20px); /* 向下移動20px */
}

.fade-up-enter-to,
.fade-up-leave-from {
  opacity: 1;
  transform: translateY(0); /* 回到原始位置 */
}

/* 淡出效果 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
  transform: translateY(0); /* 回到原始位置 */
}
</style>
